import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './Settings.css';

const NAV = [
  { to: '/settings/profile', label: 'Profile', group: 'Personal' },
  { to: '/settings/organization', label: 'Organization', group: 'Organization' },
  { to: '/settings/billing', label: 'Billing & Plan', group: 'Organization' },
  { to: '/settings/api-keys', label: 'API Keys', group: 'Organization' },
  { to: '/settings/security', label: 'Security', group: 'Organization' },
  { to: '/settings/integrations', label: 'Integrations', group: 'Organization', soon: true },
];

export default function SettingsLayout() {
  const navigate = useNavigate();
  let lastGroup = null;

  return (
    <div className="settings-page">
      <aside className="settings-sidebar">
        <button type="button" className="settings-back" onClick={() => navigate('/dashboards')}>
          <ArrowLeft size={16} /> Back to dashboards
        </button>
        <h1 className="settings-brand">Settings</h1>
        <nav className="settings-nav">
          {NAV.map((item) => {
            const showGroup = item.group !== lastGroup;
            lastGroup = item.group;
            return (
              <React.Fragment key={item.to}>
                {showGroup && <div className="settings-nav-group">{item.group}</div>}
                {item.soon ? (
                  <span className="settings-nav-link settings-nav-link--soon">
                    {item.label}
                    <em>Soon</em>
                  </span>
                ) : (
                  <NavLink
                    to={item.to}
                    className={({ isActive }) =>
                      `settings-nav-link${isActive ? ' settings-nav-link--active' : ''}`
                    }
                  >
                    {item.label}
                  </NavLink>
                )}
              </React.Fragment>
            );
          })}
        </nav>
      </aside>
      <main className="settings-main">
        <Outlet />
      </main>
    </div>
  );
}
